export function getIdsByPosts(posts) {
  const ids = []
  for (let index = 0, length = posts.length; index !== length; index++) {
    ids.push(posts[index].id)
  }
  return ids
}

export function dropPostsByIds(posts, ids) {
  const postsIds = getIdsByPosts(posts)
  for (let index = 0, length = ids.length; index !== length; index++) {
    const idIndex = postsIds.indexOf(ids[index])
    if (idIndex === -1) continue
    posts.splice(idIndex, 1)
    postsIds.splice(idIndex, 1)
  }
  return posts
}

export function getDiffPosts(posts, withList) {
  const withListIds = getIdsByPosts(withList)
  const allowedPosts = []
  for (let index = 0, length = posts.length; index !== length; index++) {
    const post = posts[index]
    if (withListIds.indexOf(post.id) === -1) {
      allowedPosts.push(post)
    }
  }
  return allowedPosts
}

export function getDuplicatedPosts(posts, withList) {
  const withListIds = getIdsByPosts(withList)
  const allowedPosts = []
  for (let index = 0, length = posts.length; index !== length; index++) {
    const post = posts[index]
    if (withListIds.indexOf(post.id) !== -1) {
      allowedPosts.push(post)
    }
  }
  return allowedPosts
}
